/*
CUSTOMIZATIONS:
- La sezione Destinatari è diventato un h2
- I valori dei destinatari ora è un elenco puntato
- il titolo 'Destinatari del bando' è stato cambiato in 'Chi può fare domanda'
*/

import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  destinatari: {
    id: 'bando_destinatari_rer',
    defaultMessage: 'Chi può fare domanda',
  },
});

const BandoTextDestinatari = ({ content }) => {
  const intl = useIntl();
  return content?.destinatari?.length > 0 ? (
    <>
      <h2 id={'header-destinatari'} className="h4">
        {intl.formatMessage(messages.destinatari)}
      </h2>
      <ul className="ps-3">
        {content.destinatari.map((item, i) => (
          <li key={'destinatari-' + i}>{item.title}</li>
        ))}
      </ul>
    </>
  ) : (
    <></>
  );
};

BandoTextDestinatari.propTypes = {
  content: PropTypes.shape({
    destinatari: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        token: PropTypes.string,
      }),
    ),
  }).isRequired,
};
export default BandoTextDestinatari;
